export { default } from "/Users/shiyo/fukuokacafenikki_ver2.0.0/RSCStarter/app/routes/diagnosis.tsx";